import { CreditCardUtilitiesServiceModule } from 'services/utilities/creditCardUtilities.service';

export const ValidateCcExpirationModule = angular
    .module('app.components.creditCards.validateCcExpiration', [
        CreditCardUtilitiesServiceModule
    ]).factory('_Validate', (creditCardUtilities) => {
        var validators = {};

        validators.expiry = (val) => {
            // valid if empty - let ng-required handle empty
            if (val === null || val.length === 0) return true;

            var obj = creditCardUtilities.parseExpiration(val);

            var month = obj.month;
            var year = obj.year;

            var currentTime;
            var expiry;
            var prefix;

            if (!(month && year)) {
                return false;
            }

            if (!/^\d+$/.test(month)) {
                return false;
            }

            if (!/^\d+$/.test(year)) {
                return false;
            }

            if (!(parseInt(month) <= 12)) {
                return false;
            }

            if (year.length === 2) {
                prefix = (new Date()).getFullYear();
                prefix = prefix.toString().slice(0, 2);
                year = prefix + year;
            }

            expiry = new Date(year, month);
            currentTime = new Date();
            expiry.setMonth(expiry.getMonth() - 1);
            expiry.setMonth(expiry.getMonth() + 1, 1);

            return expiry > currentTime;
        };

        return (type, val, ctrl, scope, attr) => {
            if (!validators[type]) {
                var types = Object.keys(validators);

                var errstr = `Unknown type for validation: ${type}. Should be one of: ${types.join(', ')}`;

                throw errstr;
            }
            return validators[type](val, ctrl, scope, attr);
        };
    })
    .factory('_ValidateWatch', (_Validate) => {
        var _validatorWatches = {};

        _validatorWatches.cvc = (type, ctrl, scope, attr) => {
            if (attr.paymentsTypeModel) {
                scope.$watch(attr.paymentsTypeModel, (newVal, oldVal) => {
                    if (newVal !== oldVal) {
                        var valid = _Validate(type, ctrl.$modelValue, ctrl, scope, attr);
                        ctrl.$setValidity(type, valid);
                    }
                });
            }
        };

        return (type, ctrl, scope, attr) => {
            if (_validatorWatches[type]) {
                return _validatorWatches[type](type, ctrl, scope, attr);
            }
        };
    })
    .directive('paymentsValidate', ($window, _Validate, _ValidateWatch) => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, elem, attr, ctrl) => {
                var type = attr.paymentsValidate;

                _ValidateWatch(type, ctrl, scope, attr);

                var validateFn = (val) => {
                    var valid = _Validate(type, val, ctrl, scope, attr);
                    ctrl.$setValidity(type, valid);
                    return valid ? val : undefined;
                };

                ctrl.$formatters.push(validateFn);
                ctrl.$parsers.push(validateFn);
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/creditCards/validateCcExpiration.directive.js